import React from "react";
import { LegalLayout, H2, P, UL, LI } from "@/components/LegalLayout";

export default function PrivacyPolicy() {
  return (
    <LegalLayout
      title="Privacy Policy"
      updated="June 1, 2026"
      intro="Your reflections are personal. This policy explains what Next Time collects, how we use it, and the control you have over your data."
    >
      <P>Next Time (“we”, “us”, “our”) provides a self-improvement app that helps you learn from difficult moments and practice conversations. This Privacy Policy applies to the Next Time mobile apps and website (the “Service”).</P>

      <H2>1. Information we collect</H2>
      <UL>
        <LI><strong>Account information.</strong> If you create an account, we store a basic identifier (such as an email or an anonymous device ID). Guest sessions are tied only to a randomly generated device ID.</LI>
        <LI><strong>Content you create.</strong> The moments you capture, role-play messages, reflections, interpretations you confirm or dismiss, plans, and playbooks.</LI>
        <LI><strong>Purchase records.</strong> When you buy a subscription or points, Apple/Google and our payments provider (RevenueCat) process the payment; we receive transaction identifiers to credit your account. We never receive your full card details.</LI>
        <LI><strong>Preferences.</strong> Your chosen focus areas, coaching style, and notification settings.</LI>
        <LI><strong>Usage data.</strong> Basic, aggregated information about how the Service is used (for example, how many role-plays were completed), used to improve the product.</LI>
      </UL>

      <H2>2. How we use your information</H2>
      <UL>
        <LI>To generate AI analysis, role-play responses, coaching feedback, and personalized scenarios.</LI>
        <LI>To show your history, patterns, and progress over time.</LI>
        <LI>To operate, maintain, and improve the Service.</LI>
        <LI>To provide support and respond to your requests.</LI>
      </UL>

      <H2>3. AI processing</H2>
      <P>To provide feedback and role-play, the content you submit is processed by third-party large language model providers acting on our behalf. We do not sell your personal content. Interpretations you dismiss are treated as “not true” and are not reused as established facts about you.</P>

      <H2>4. Data sharing</H2>
      <P>We do not sell your personal information. We share data only with service providers who help us operate the Service (such as hosting and AI processing), under obligations of confidentiality, or when required by law.</P>

      <H2>5. Data retention and your controls</H2>
      <UL>
        <LI><strong>Export.</strong> You can export your data at any time from Settings.</LI>
        <LI><strong>Delete.</strong> You can delete individual moments, clear AI memory, or delete all of your content.</LI>
        <LI>We retain content while your account is active and delete it within a reasonable period after you request deletion, except where retention is required by law.</LI>
      </UL>

      <H2>6. Security</H2>
      <P>We use reasonable technical and organizational measures to protect your information. No method of transmission or storage is completely secure, so we cannot guarantee absolute security.</P>

      <H2>7. Children</H2>
      <P>The Service is not directed to children under 13 (or the minimum age required in your jurisdiction), and we do not knowingly collect their information.</P>

      <H2>8. Not a medical service</H2>
      <P>Next Time is a practice and reflection tool. It is not a healthcare provider and does not provide medical, psychological, or crisis services. If you are in crisis, contact your local emergency services.</P>

      <H2>9. Changes to this policy</H2>
      <P>We may update this policy from time to time. Material changes will be reflected by updating the “Last updated” date above.</P>

      <H2>10. Contact us</H2>
      <P>Questions about privacy? Email <a href="mailto:decompresspause@gmail.com" className="underline hover:text-ink">decompresspause@gmail.com</a>.</P>
    </LegalLayout>
  );
}
